import { MESSAGES_COPY } from '../../../global/ui/messages/COPY';
import { PLACEHOLDERS_COPY } from '../../../global/ui/placeholders/COPY';

export const COMPANY_NAME = {
	MIN_LENGTH: 1,
	PATTERN: /^[a-zA-Z0-9 ]+$/u,
	PLACEHOLDER: PLACEHOLDERS_COPY.COMPANY_NAME,
	REQUIRED_MESSAGE: MESSAGES_COPY.PLEASE_ENTER_YOUR_COMPANY_NAME
};
